import { graphql } from "react-apollo";
import { getSessionInformation } from "cci-data";
import hasPermissions from ".";

/**
 * Component that renders children only if the logged in user has the specified permissions.
 */
const SecuredComponent = ({ data, checkPermissions, children }) => {
  if (data.error) {
    /* This stub handles the stacktrace generated in the browser where Apollo says we haven't handled the exception where in fact we have */
  }

  // Render children either when there is no checkPermissions props or when the user has the permissions specified in checkPermissions props
  if (
    !checkPermissions ||
    (data.sessionInformation &&
      data.sessionInformation.user &&
      hasPermissions(
        data.sessionInformation.user.permissions,
        checkPermissions
      ))
  ) {
    return children;
  }

  return null;
};

export default graphql(getSessionInformation)(SecuredComponent);
